// Copyright (c) 2020, Picsa Advisory Services (Pty) Ltd. All rights reserved

import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'

import { EmployeeList } from '../../../containers'


class SelectEmployerEmployees extends React.PureComponent {
  static propTypes = {
    onSelectionChange: PropTypes.func.isRequired,
    selected: PropTypes.array,
    className: PropTypes.string
  }

  render() {
    return (
      <EmployeeList
        selectableRows={true}
        onSelectionChange={this.props.onSelectionChange}
        className={this.props.className}
      />
    )
  }
}

export default withRouter(SelectEmployerEmployees)



// WEBPACK FOOTER //
// ./src/components/messageplus/select-employer-employees/index.js